<template>
  <div class="reminder-input-container">
    <div class="form-group">
      <label class="form-label">
        {{ $t('MACROS.REMINDER.NOTE_LABEL') }}
        <span class="text-red-500">*</span>
      </label>
      <textarea
        v-model="reminderNote"
        class="form-textarea"
        rows="4"
        :placeholder="$t('MACROS.REMINDER.NOTE_PLACEHOLDER')"
        @input="onNoteChange"
      />
      <small class="form-help">{{ $t('MACROS.REMINDER.NOTE_HELP') }}</small>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        note: '',
      }),
    },
  },
  data() {
    return {
      reminderNote: '',
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.reminderNote = newVal.note || '';
        } else {
          this.reminderNote = '';
        }
      },
    },
  },
  methods: {
    onNoteChange() {
      this.updateValue();
    },
    updateValue() {
      const valueToEmit = {
        note: this.reminderNote || '',
      };
      
      this.$emit('input', valueToEmit);
    },
  },
};
</script>

<style scoped lang="scss">
.reminder-input-container {
  @apply mt-4 space-y-4;
}

.form-group {
  @apply flex flex-col space-y-2;
}

.form-label {
  @apply text-sm font-medium text-slate-700 dark:text-slate-200;
}

.form-textarea {
  @apply w-full px-3 py-2 border border-slate-200 dark:border-slate-700 rounded 
         bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100
         focus:outline-none focus:ring-1 focus:ring-woot-500 focus:border-woot-500
         transition-colors duration-150;
  resize: vertical;
  font-size: 14px;
  line-height: 1.5;
  
  &::placeholder {
    @apply text-slate-400 dark:text-slate-500;
  }
  
  &:hover {
    @apply border-slate-300 dark:border-slate-600;
  }
}

.form-help {
  @apply text-xs text-slate-500 dark:text-slate-400 mt-1;
}
</style>

